import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { HomeConstants } from '../../home/store/home.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getSceneDescription } from '../../sceneDescription/saga/getSceneDescription.saga'
import { getPatientDemographics } from '../../patientDemographics/saga/getPatientDemographics.saga'
import { setIsPCRError, setIsPCROpening } from '../store/home.actions'
import { getAssessedByOptions } from '../../../components/procedure/saga/getAssessedByOptions.saga'
import { getBurns } from '../../additionalAssessments/bodyAssessment/burns/saga/getBurns.saga'
import { getDrainsAndTubes } from '../../additionalAssessments/bodyAssessment/drainsTubes/saga/getDrainsAndTubes.saga'
import { getObstetrics } from '../../additionalAssessments/bodyAssessment/obstetrics/saga/getObstetrics.saga'
import { getAssessments } from '../../additionalAssessments/saga/setAssessmentList.saga'
import { setSelectedExamOptions } from '../../additionalAssessments/saga/setSelectedExamOption.saga'
import { getAuthorizationInformation } from '../../authorizationInformation/saga/getAuthorizationInformation.saga'
import { checkImportedCadData } from '../../cadImport/saga/checkImportedCadData.saga'
import { getMotorVehicleIncident } from '../../ccHpi/motorVehicleIncident/saga/getMotorVehicleIncident.saga'
import { getCcHpi } from '../../ccHpi/saga/getCcHpi.saga'
import { getFluids } from '../../fluids/saga/getFluids.saga'
import { getCmsInformation } from '../../cmsInformation/saga/getCmsInformation.saga'
import { setTimeZone } from '../../configurations/saga/setTimeZone.saga'
import { getCustomSignatures } from '../../customSignature/saga/getCustomSignatures.saga'
import { getDestinationAddress } from '../../destinationAddress/saga/getDestinationAddress.saga'
import { getDiagnosis } from '../../diagnosis/saga/getDiagnosis.saga'
import { getExposureState } from '../../exposure/saga/getExposureState.saga'
import { setExposureCrewList } from '../../exposure/saga/setExposureCrewList.saga'
import { setFactorsAffectingCareConditionalValues } from '../../factorsAffectingCare/saga/setFactorsAffectingCareConditionalValues.saga'
import { getInitialAssessmentAirway } from '../../initialAssessments/airway/saga/getInitialAssessmentAirway.saga'
import { getPulses } from '../../initialAssessments/cardio/pulses/saga/getPulses.saga'
import { getInitialAssessmentCardio } from '../../initialAssessments/cardio/saga/getInitialAssessmentCardio.saga'
import { getGlassgowCommaScore } from '../../initialAssessments/neuro/glassgowCommaScore/saga/getGlassgowComaScore.saga'
import { getMotorSensory } from '../../initialAssessments/neuro/motorSensoryAssessment/saga/getMotorSensoryAssessment.saga'
import { getPTS } from '../../initialAssessments/neuro/pediatricTraumaScore/saga/getPts.saga'
import { getPupils } from '../../initialAssessments/neuro/pupils/saga/getPupils.saga'
import { getRTS } from '../../initialAssessments/neuro/revisedTraumaScore/saga/getRts.saga'
import { getNeuro } from '../../initialAssessments/neuro/saga/getNeuro.saga'
import { getWasPatientImmobilized } from '../../initialAssessments/neuro/wasPatientImmobilized/saga/getWasPatientImmobilized.saga'
import { getRespiratory } from '../../initialAssessments/respiratory/saga/getRespiratory.saga'
import { setInsuranceInformation } from '../../insuranceInformation/saga/setInsuranceInformation.saga'
import { getNarrative } from '../../narrative/saga/getNarrativeText.saga'
import { getPatientAllergiesFoodEnvironmentButtonWallOptions } from '../../options/saga/getPatientAllergiesFoodEnvironmentButtonWallOptions.saga'
import { getPatientAllergiesMedicationButtonWallOptions } from '../../options/saga/getPatientAllergiesMedicationButtonWallOptions.saga'
import { getPatientAllergiesOptions } from '../../options/saga/getPatientAllergiesOptions.saga'
import { getSelectedCrewMembers } from '../../options/saga/getSelectedCrewMembers.saga'
import { getStrokeScaleAndScore } from '../../options/saga/getStrokeScaleAndScore.saga'
import { getPatientAllergies } from '../../patientAllergies/saga/getPatientAllergies.saga'
import { getEmployer } from '../../patientDemographics/employer/saga/getEmployer.saga'
import { getPatientImmunizations } from '../../patientImmunizations/saga/getPatientImmunizations.saga'
import { getPatientInformation } from '../../patientInformation/saga/getPatientInformation.saga'
import { getPatientMedicalHistory } from '../../patientMedicalHistory/saga/getPatientMedicalHistory.saga'
import { getPatientMedications } from '../../patientMedications/saga/getPatientMedications.saga'
import { getPcsInformation } from '../../pcsInformation/saga/getPcsInformation.saga'
import { getPickupAddress } from '../../pickupAddress/saga/getPickupAddress.saga'
import { getQuickActions } from '../../quickActions/saga/getQuickActions.saga'
import { getRuleErrors } from '../../rules/saga/getRuleErrors.saga'
import { getSubmitChart } from '../../submitChart/saga/getSubmitChart.saga'
import { getTimelineItems } from '../../timeline/saga/getTimelineItems.saga'
import { getTripInformation } from '../../tripInformation/saga/getTripInformation.saga'
import { setCalculateVehicleUSNG } from '../../tripInformation/saga/setCalculateVehicleUSNG.saga'
import { getRelationshipsAndGuarantors } from '../../relationshipsAndGuarantors/saga/getRelationshipsAndGuarantors.saga'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getPcrIdSelector } from '../selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { setPaymentInformation } from '../../paymentInformation/saga/setPaymentInformation.saga'
import { getSignatures } from '../../signatures/saga/getSignatures.saga'
import { getTimes } from '../../times/saga/getTimes.saga'
import { setExportDatasets } from '../../configurations/saga/setExportDatasets.saga'
import { getSignerData } from '../../completeChart/saga/getSignerData.saga'
import { getPDFAttachments } from '../../fillablePDFs/saga/getPDFAttachments.saga'
import { ensurePridFetched } from './ensurePridFetched.saga'
import { loadBackupMetadataForChart } from '../../pcrBackup/saga/loadBackupMetadata.saga'
import { ISubmitChartState } from '../../submitChart/store/submitChart.types'
import { initialSubmitChartState } from '../../submitChart/store/submitChart.reducers'

export function* loadPCR() {
  try {
    const pcrID: string = yield select(getPcrIdSelector)
    const serviceId: string = yield select(getServiceIdSelector)

    if (!pcrID) throw Error('PCR not found')

    const pcrDocsService = new PcrDocsService(serviceId)
    let pcrDoc: IPcr | undefined | null = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)

    if (!pcrDoc) throw Error(`PCR with pcrId ${pcrID} not found`)

    yield call(loadBackupMetadataForChart, pcrDoc.pcrId)
    const fetchedPrid: string | null = yield call(ensurePridFetched, pcrDoc)
    if (fetchedPrid)
      pcrDoc = {
        ...pcrDoc,
        prid: fetchedPrid,
        submitChart: { ...(pcrDoc.submitChart ?? initialSubmitChartState), prid: fetchedPrid } as ISubmitChartState,
      }

    yield all([
      call(getAssessedByOptions),
      call(getBurns, pcrDoc),
      call(getDrainsAndTubes, pcrDoc),
      call(getObstetrics, pcrDoc),
      call(getAssessments, pcrDoc),
      call(setSelectedExamOptions),
      call(getAuthorizationInformation, pcrDoc),
      call(checkImportedCadData, pcrDoc),
      call(getMotorVehicleIncident, pcrDoc),
      call(getCcHpi, pcrDoc),
      call(getFluids, pcrDoc),
      call(getCmsInformation, pcrDoc),
      call(setTimeZone),
      call(getCustomSignatures, pcrDoc),
      call(getDestinationAddress, pcrDoc),
      call(getDiagnosis, pcrDoc),
      call(getExposureState, pcrDoc),
      call(setExposureCrewList, pcrDoc),
      call(setFactorsAffectingCareConditionalValues),
      call(getInitialAssessmentAirway, pcrDoc),
      call(getPulses, pcrDoc),
      call(getInitialAssessmentCardio, pcrDoc),
      call(getGlassgowCommaScore, pcrDoc),
      call(getMotorSensory, pcrDoc),
      call(getPTS, pcrDoc),
      call(getPupils, pcrDoc),
      call(getRTS, pcrDoc),
      call(getNeuro, pcrDoc),
      call(getWasPatientImmobilized, pcrDoc),
      call(getRespiratory, pcrDoc),
      call(setInsuranceInformation, pcrDoc),
      call(getNarrative, pcrDoc),
      call(getPatientAllergiesFoodEnvironmentButtonWallOptions),
      call(getPatientAllergiesMedicationButtonWallOptions),
      call(getPatientAllergiesOptions),
      call(getSelectedCrewMembers),
      call(getStrokeScaleAndScore),
      call(getPatientAllergies, pcrDoc),
      call(getEmployer, pcrDoc),
      call(getPatientDemographics, pcrDoc),
      call(getPatientImmunizations, pcrDoc),
      call(getPatientInformation, pcrDoc),
      call(getPatientMedicalHistory, pcrDoc),
      call(getPatientMedications, pcrDoc),
      call(setPaymentInformation, pcrDoc),
      call(getPcsInformation, pcrDoc),
      call(getPickupAddress, pcrDoc),
      call(getQuickActions),
      call(getRelationshipsAndGuarantors, pcrDoc),
      call(getRuleErrors, pcrDoc),
      call(getSceneDescription, pcrDoc),
      call(getSignatures, pcrDoc),
      call(getSubmitChart, pcrDoc),
      call(getTimelineItems, pcrDoc),
      call(getTimes, pcrDoc),
      call(getTripInformation, pcrDoc),
      call(setCalculateVehicleUSNG, pcrDoc),
      call(setExportDatasets),
      call(getSignerData, pcrDoc),
      call(getPDFAttachments, pcrDoc),
    ])
    yield put(setIsPCROpening(false))
  } catch (e) {
    yield put(setIsPCROpening(false))
    yield put(throwPcrException(`loadPCR() error: ${e}`))
    yield put(setIsPCRError(true))
  }
}

export function* loadPCRSaga() {
  yield takeLatest([HomeConstants.ON_SELECT_PCR], performWithMutexHOG, loadPCR)
}
